import dayjs from "dayjs";
import {
  SchedulerCloserDTO,
  SchedulerClosersDTO,
  SchedulerExcludedCloserDTO,
} from "../HubSpot/useGetSchedulerClosers.ts";

export const MISALIGNED_SLOTS_LOOKAHEAD_DAYS = 7;

const DEACTIVATED_USER_REASON = "hubspot_user_not_found";

export function misalignedSlotsRange(): { from: dayjs.Dayjs; to: dayjs.Dayjs } {
  const from = dayjs().tz("Europe/Rome").startOf("day");
  return {
    from,
    to: from.add(MISALIGNED_SLOTS_LOOKAHEAD_DAYS, "day").endOf("day"),
  };
}

export function schedulerCloserIssues(closer: SchedulerCloserDTO): string[] {
  return [
    ...(closer.calendarSyncEnabled
      ? ["Sincronizzazione calendario attiva"]
      : []),
    ...(closer.invalidBlock
      ? [`Blocco non valido: ${closer.invalidBlock}`]
      : []),
    ...(closer.capacity === null ? ["Cap non impostato"] : []),
  ];
}

export function isExclusionToFix(
  excluded: SchedulerExcludedCloserDTO,
): boolean {
  return excluded.reason !== DEACTIVATED_USER_REASON;
}

export function hasSchedulerCloserIssues(
  closers: SchedulerClosersDTO,
): boolean {
  return (
    closers.closers.some((c) => schedulerCloserIssues(c).length > 0) ||
    closers.excluded.some(isExclusionToFix)
  );
}
